export enum StatusRetorno {
  ERROR = 'ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

export interface Retorno<T> {
  status: StatusRetorno;
  response: T;
}
